import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { VehicleBlockingEvent } from "../../../components/FleetManagement/types/FleetManagement.types";

export type CreateBlockingEventPayload = {
  vehicleId: number;
  start: string;
  end: string;
  reason?: string | null;
  createdBy?: string;
};

/**
 * Creates a blocking event (POST /fleet/vehicles/:vehicleId/blocking-events).
 * Use mutateAsyncSafe when calling from UI so errors are handled in the hook and the promise never rejects.
 */
export function useRemoteCreateBlockingEvent() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<VehicleBlockingEvent, RemoteApiError, CreateBlockingEventPayload>({
    key: ["fleet", "create-blocking-event"],
    url: payload => `/fleet/vehicles/${payload.vehicleId}/blocking-events`,
    method: "post",
    body: ({ start, end, reason, createdBy }) => ({
      start,
      end,
      reason,
      ...(createdBy && { createdBy })
    }),
    snackbarTextOnSuccess: t("Blocking event created"),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(["fleet", "vehicles", variables.vehicleId, "blocking-events"]);
      queryClient.invalidateQueries(["fleet", "blocking-events", "calendar"]);
    }
  });
}
